import { render, staticRenderFns } from "./fileDownload.vue?vue&type=template&id=642f23c6&scoped=true&"
import script from "./fileDownload.vue?vue&type=script&lang=js&"
export * from "./fileDownload.vue?vue&type=script&lang=js&"
import style0 from "./fileDownload.vue?vue&type=style&index=0&id=642f23c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f23c6",
  null
  
)

export default component.exports